<template>
  <div
id="routeinfo"
class="main-tab-content"
>
    <div class="">
      <h3>巴士路線搜尋</h3>
    </div>
    <div class="row">
      <autocomplete
        :debounce="800"
        :on-select="selectListItem"
        :on-should-get-data="getRouteInfo"
        :on-should-render-child="printRouteInfoItem"
        :url="autocompleteUrl"
        anchor="title"
        class="form-control"
        label="writer"
        placeholder="Enter route name here"
>
      </autocomplete>
    </div>
    <div class="row">
      <router-view></router-view>
    </div>

    <div class="row">
      <div style="clear: both; width: 100%;"></div>
    </div>
  </div>
</template>

<script>
import Autocomplete from 'vue2-autocomplete-js';

// import FavouriteHome from '../Favourite/FavouriteHome'
// import NearbyRoutes from '../NearbyRoutes/NearbyRoutes'
// import TdNews from '../Td/TdNews'
import {ROUTE_SUGGEST} from "../../config/paths/apiPaths";
import {mapMutations} from 'vuex';

// import normalRouteSuggest from './RouteSuggestion/normalRouteSuggest'
// import {ROUTE_DETAILS} from "../../config/paths/appPaths";

export default {
  name: "RouteInfo",
  components: {
    // FavouriteHome, NearbyRoutes, TdNews,
    Autocomplete,
    // normalRouteSuggest,
  },
  data() {
    return {
      autocompleteUrl: ROUTE_SUGGEST,
    };
  },
  computed: {},

  methods: {
    ...mapMutations('stopMenu', ['hideStopMenu']),
    ...mapMutations('googleMap', ['cleanRouteLine']),
    getRouteInfo(routeName) {
      return fetch(`${ROUTE_SUGGEST}/${routeName}`)
        .then(response => response.json())
        .then(json => json.data.records);
    },
    selectListItem(data) {
      this.hideStopMenu(); // todo: change to "clear stop menu"
      this.cleanRouteLine();
      this.$router.push({path: `/routeinfo/route/${data.routeid}`});

    },
    printRouteInfoItem(data) {
      let specialRoute = '';
      if (data.service_mode === 'T') {
        specialRoute = `
                    <span
                        class="special-route"
                        v-if="data.service_mode === 'T'"
                    >
                        <i class="md-icon">priority_high</i>
                    </span>
                    `;
      }

      return `
        <a>
            <img
                src="https://roadhk.com/roadhk/img/bus.png"
                class="img-bus"
            />
            <span class="routec">${data.routec} ${data.startc}-${data.destinc}</span>
            ${specialRoute}
        </a>
        `;
    },
    openRouteDetails(id) {
      this.$router.push(`/routeinfo/route/${id}`);
    }
  }

}
</script>

<style scoped>
.img-bus {
  width: 24px;
  height: 24px;
}
</style>
